// src/pages/admin/AdminResourceEditorPage.tsx
import React from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { useAdminResource, useCreateResource, useUpdateResource } from '../hooks';
import { ResourceEditor } from '../components';
import { useToast } from '@/core/hooks/useToast';

export const AdminResourceEditorPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { toast } = useToast();
  const isNew = !id || id === 'new';

  const { data: resource, isLoading } = useAdminResource(id!, { enabled: !isNew });
  const createMutation = useCreateResource();
  const updateMutation = useUpdateResource();

  const handleSave = (data: any) => {
    if (isNew) {
      createMutation.mutate(data, {
        onSuccess: (result) => {
          toast({ title: 'Resource created', variant: 'success' });
          navigate(`/admin/resources/edit/${result.id}`);
        },
      });
    } else {
      updateMutation.mutate({ id: id!, data }, {
        onSuccess: () => {
          toast({ title: 'Resource updated', variant: 'success' });
        },
      });
    }
  };

  if (!isNew && isLoading) {
    return (
      <div className="animate-pulse space-y-4">
        <div className="h-8 bg-gray-200 rounded w-48" />
        <div className="h-96 bg-gray-200 rounded" />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-4">
        <Link to="/admin/resources" className="text-warm-gray hover:text-navy">
          <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </Link>
        <div>
          <h1 className="text-2xl font-display font-semibold text-navy">
            {isNew ? 'Create Resource' : 'Edit Resource'}
          </h1>
          <p className="text-warm-gray">
            {isNew ? 'Add a new educational resource' : resource?.title}
          </p>
        </div>
      </div>

      <ResourceEditor
        resource={resource}
        onSave={handleSave}
        isSaving={createMutation.isPending || updateMutation.isPending}
      />
    </div>
  );
};

export default AdminResourceEditorPage;



